import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const CATEGORIES = ["Concert", "Festival", "Sport", "Marché", "Repas", "Soirée"];

export default function EventFormFields({ form, setForm }) {
  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const updateCategory = (v) => setForm({ ...form, category: v });

  const inputCls = "h-11 rounded-xl border-[#F0E0CC] focus-visible:ring-sage/20 focus-visible:border-sage";

  return (
    <div className="space-y-5">
      <div className="space-y-2">
        <Label htmlFor="title" className="text-ink font-medium">Titre *</Label>
        <Input id="title" required minLength={2} value={form.title} onChange={update("title")} className={inputCls} data-testid="event-title-input" />
      </div>

      <div>
        <Label className="text-ink font-medium block mb-2">Dates *</Label>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="space-y-1.5">
            <Label htmlFor="date" className="text-xs uppercase tracking-wider text-muted_text font-semibold">Date de début</Label>
            <Input id="date" type="date" required value={form.date} onChange={update("date")} className={inputCls} data-testid="event-date-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="end_date" className="text-xs uppercase tracking-wider text-muted_text font-semibold">Date de fin <span className="normal-case font-normal text-muted_text">(facultatif)</span></Label>
            <Input
              id="end_date"
              type="date"
              value={form.end_date || ""}
              min={form.date || undefined}
              onChange={update("end_date")}
              className={inputCls}
              data-testid="event-end-date-input"
            />
          </div>
        </div>
        <p className="text-xs text-muted_text mt-1.5">Laissez la date de fin vide si l'événement ne dure qu'une seule journée.</p>
      </div>

      <div>
        <Label className="text-ink font-medium block mb-2">Horaires *</Label>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="space-y-1.5">
            <Label htmlFor="time" className="text-xs uppercase tracking-wider text-muted_text font-semibold">Heure de début</Label>
            <Input id="time" type="time" required value={form.time} onChange={update("time")} className={inputCls} data-testid="event-time-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="end_time" className="text-xs uppercase tracking-wider text-muted_text font-semibold">Heure de fin <span className="normal-case font-normal text-muted_text">(facultatif)</span></Label>
            <Input
              id="end_time"
              type="time"
              value={form.end_time || ""}
              onChange={update("end_time")}
              className={inputCls}
              data-testid="event-end-time-input"
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div className="space-y-2">
          <Label htmlFor="commune" className="text-ink font-medium">Lieu (Commune) *</Label>
          <Input id="commune" required value={form.commune} onChange={update("commune")} className={inputCls} placeholder="Ex : Toulouse" data-testid="event-commune-input" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="category" className="text-ink font-medium">Catégorie *</Label>
          <Select value={form.category} onValueChange={updateCategory}>
            <SelectTrigger id="category" className="h-11 rounded-xl border-[#F0E0CC] focus:ring-sage/20" data-testid="event-category-select">
              <SelectValue placeholder="Choisir une catégorie" />
            </SelectTrigger>
            <SelectContent>
              {CATEGORIES.map((c) => (
                <SelectItem key={c} value={c} data-testid={`event-category-option-${c.toLowerCase()}`}>{c}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="image_url" className="text-ink font-medium">Image de couverture (URL) *</Label>
        <Input id="image_url" type="url" required value={form.image_url} onChange={update("image_url")} className={inputCls}
          placeholder="https://…" data-testid="event-image-input" />
        {form.image_url && (
          <div className="mt-2 rounded-xl overflow-hidden border border-[#F0E0CC] aspect-[16/9] bg-[#FEF3C7]">
            <img src={form.image_url} alt="Aperçu" className="w-full h-full object-cover"
              onError={(e) => { e.currentTarget.style.display = "none"; }} />
          </div>
        )}
      </div>

      <div className="space-y-2">
        <Label htmlFor="description" className="text-ink font-medium">Description *</Label>
        <Textarea id="description" required minLength={10} rows={5} value={form.description} onChange={update("description")}
          className="rounded-xl border-[#F0E0CC] focus-visible:ring-sage/20 focus-visible:border-sage"
          placeholder="Décrivez votre événement en quelques phrases…" data-testid="event-description-input" />
      </div>
    </div>
  );
}
